import androidx.compose.runtime.CompositionLocalProvider
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Idris Adetunmbi - Software Engineer"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register("/") { dev.iad.portfoliowebsite.pages.IndexPage() }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("footer", dev.iad.portfoliowebsite.components.FooterStyle)
        ctx.theme.registerStyle("page-content",
                dev.iad.portfoliowebsite.components.PageContentStyle)
        ctx.theme.registerStyle("container",
                dev.iad.portfoliowebsite.pagescomponents.index.sections.ContainerStyle)
        ctx.theme.registerStyle("submit-button",
                dev.iad.portfoliowebsite.pagescomponents.index.sections.SubmitButtonStyle)
        ctx.theme.registerStyle("input-field",
                dev.iad.portfoliowebsite.pagescomponents.index.sections.InputFieldStyle)
        ctx.theme.registerStyle("experiences-mobile",
                dev.iad.portfoliowebsite.pagescomponents.index.sections.ExperiencesMobileStyle)
        ctx.theme.registerStyle("experiences-desktop",
                dev.iad.portfoliowebsite.pagescomponents.index.sections.ExperiencesDesktopStyle)
        ctx.theme.registerStyle("experience-content",
                dev.iad.portfoliowebsite.pagescomponents.index.sections.ExperienceContentStyle)
        ctx.theme.registerStyle("experience-mobile-date-content",
                dev.iad.portfoliowebsite.pagescomponents.index.sections.ExperienceMobileDateContentStyle)
        ctx.theme.registerStyle("projects-grid",
                dev.iad.portfoliowebsite.pagescomponents.index.sections.ProjectsGridStyle)
        ctx.theme.registerStyle("project",
                dev.iad.portfoliowebsite.pagescomponents.index.sections.ProjectStyle)
        ctx.theme.registerStyle("project-content-container",
                dev.iad.portfoliowebsite.pagescomponents.index.sections.ProjectContentContainerStyle)
        ctx.theme.registerStyle("project-info-toggle-button",
                dev.iad.portfoliowebsite.pagescomponents.index.sections.ProjectInfoToggleButtonStyle)
        ctx.theme.registerStyle("project-info-toggle-button-icon",
                dev.iad.portfoliowebsite.pagescomponents.index.sections.ProjectInfoToggleButtonIconStyle)
        ctx.theme.registerStyle("project-content",
                dev.iad.portfoliowebsite.pagescomponents.index.sections.ProjectContentStyle)
        ctx.theme.registerStyle("project-summary-text",
                dev.iad.portfoliowebsite.pagescomponents.index.sections.ProjectSummaryTextStyle)
        ctx.theme.registerStyle("projects-filter-button",
                dev.iad.portfoliowebsite.pagescomponents.index.sections.ProjectsFilterButtonStyle)
        ctx.theme.registerVariant("-uncolored", dev.iad.portfoliowebsite.UncoloredButtonVariant
        )
        ctx.theme.registerVariant("-circle",
                dev.iad.portfoliowebsite.pagescomponents.index.sections.CircleButtonVariant
        )
        ctx.theme.registerKeyframes("side-menu-slide-in",
                dev.iad.portfoliowebsite.pagescomponents.index.sections.SideMenuSlideInAnim)
        dev.iad.portfoliowebsite.initSiteStyles(ctx)
        dev.iad.portfoliowebsite.initTheme(ctx)
    }

    router.tryRoutingTo(BasePath.remove(window.location.href.removePrefix(window.origin)),
            UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        dev.iad.portfoliowebsite.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
